import { Component } from "react";
import Loader from "../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";
import { responseError } from "../../utils/constants";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Header from '../../common_components/Header';
import { get_report_list_action } from "../../actions/report_action/report_action";
import Footer from "../../common_components/Footer";
import MobileHeader from "../../common_components/mobileHeader";
class ReportList extends Component {
    // intialize constructor
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            panel: null,
            reportList: []
        }

    }
    componentDidMount() {
        console.log("componentDidMount called");

        if (JSON.parse(sessionStorage.getItem("AwardsUserLoginData")) == null) {
            this.props.navigate("/login");
            return;
        }

        if (sessionStorage.getItem("role_id") == 2) {
            this.props.navigate("/juryDashboard");
            return;
        }

        this.getReportList();
    }


    handleChange(panel) {
        if (panel == this.state.panel) {
            this.setState({ panel: null })
        }
        else {
            this.setState({ panel: panel })
        }
    }

    getReportList() {
        console.log('enter')
        this.setState({ isLoading: true })
        this.props.get_report_list_action()
            .then((data) => {
                this.setState({ isLoading: false })
                if (data.error != 1) {
                    this.createReportList(data.data)
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    responseError(data)
                }
            })
            .catch((err) => {
                this.setState({ isLoading: false })

                console.log(err)
            })
    }

    createReportList(list) {
        let tempReportGroupList = [];
        let tempList = [];

        for (let i = 0; i < list.length; i++) {
            if (!tempReportGroupList.includes(list[i].report_group_id)) {
                tempReportGroupList.push(list[i].report_group_id);
                const obj = {
                    report_group_id: list[i].report_group_id,
                    ReportGroup: list[i].ReportGroup
                };
                tempList.push(obj);
            }
        }

        for (let i = 0; i < tempList.length; i++) {
            let tempSubReportList = [];
            for (let j = 0; j < list.length; j++) {
                if (tempList[i].report_group_id === list[j].report_group_id) {
                    tempSubReportList.push(list[j]);
                }
            }
            tempList[i].subReportList = tempSubReportList;
        }

        setTimeout(() => {
            this.setState({ reportList: tempList });
        }, 100);
    }

    reportNavigate(report_id, ReportGroup) {

        this.props.navigate('/reportGenerator', { state: { report_id: report_id, ReportGroup: ReportGroup } })


    }


    render() {
        const { isLoading, panel, reportList } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <main id="main">

                    <div className="website-view">
                        <Header data={[8]} />
                    </div>
                    <div className="mobile-view">
                        <MobileHeader data={[8]} />
                    </div>
                    <section class='header_margin_top'>
                        <div className="container-fluid">
                            <div className="page-header ml-2">
                                <h2 className="mb-3 dashboard-tit py-0 blog-name blog-name-1 mt-2">Reports</h2>
                            </div>
                            <div class="col-xl-12 p-0">
                                {reportList.length > 0 ? reportList.map((data, i) => (
                                    <Accordion key={i} className="m-1 p-0 border" expanded={panel === i} onChange={() => this.handleChange(i)}>
                                        <AccordionSummary className="py-1" style={{ minHeight: '35px', borderBottom:'1px solid #ddd', borderBottom:'1px solid #ddd',   }}
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls={`panel${i}-content`}
                                            id={`panel${i}-header`}
                                        >
                                            <Typography className="m-0" sx={{ width: '33%', flexShrink: 0 }}>
                                                {data.ReportGroup}
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Typography component="div">
                                                <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
                                                    {data.subReportList.length > 0 ? data.subReportList.map((subdata, index) => (
                                                        <li
                                                            key={index}
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => this.reportNavigate(subdata.report_id, subdata.ReportGroup)}
                                                            className="mb-2"
                                                        >
                                                            <a>{`${index + 1}.`} {subdata.report_name}</a>
                                                        </li>
                                                    )) : (
                                                        <li>No Subreport Found</li>
                                                    )}
                                                </ul>
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                )) : (
                                    <div className="text-center">No Report Found</div>
                                )}
                            </div>
                        </div>
                    </section>
                </main >
                <Footer />

            </>
        )
    }
}

export default withRouter(connect(null, { get_report_list_action })(ReportList))